export interface Chunk {
    id: number;
    text: string;
    characters: number;
}

export const mockChunks: Chunk[] = [
    {
        id: 1,
        text: '编码规范 1 目的 通过遵循良好的编码规范提高高质量代码，让代码的可读性更强，让团队开发可以更高效，提高团队编码效率，避免不必要的问题，降低后期维护开发成本。',
        characters: 79
    },
    {
        id: 2,
        text: '2 范围 适用于本公司的 Java 后台开发、Python 工程开发、Python 算法开发和 Web 前端开发人员。',
        characters: 59
    },
    {
        id: 3,
        text: '3 职责 开发人员负责遵循此编码规范与流程完成项目开发的编码工作。',
        characters: 33
    },
    {
        id: 4,
        text: '4 规范 4.1 Java 编程规范 4.1.1 格式规范 4.1.1.1 缩进 使用配置文件进行格式化：配置文件中一个 TAB 等于 4 个空格。',
        characters: 74
    },
    {
        id: 5,
        text: '4.1.1.2 行长度 每行 100 字符',
        characters: 21
    },
    {
        id: 6,
        text: '注：使用 eclipse 自带的 Format 方法（快捷键：Ctrl+Shift+F）时，需要配置"Maximum line width"设置长度为 100。',
        characters: 80
    },
    {
        id: 7,
        text: '4.1.1.3 声明 4.1.1.3.1 声明变量、常量 一行只声明一个变量或常量：在代码块的开始处声明实例变量，不要在首次用到该变量时才声明【推荐】。',
        characters: 76
    },
    {
        id: 8,
        text: '4.1.1.3.2 声明类 左大括号"{"位于声明语句同行的末尾，右大括号"}"另起一行；方法与方法之间以空行分隔。',
        characters: 58
    },
    {
        id: 9,
        text: '4.1.1.4 语句 可以使用 eclipse 自带的 Format 方法（快捷键：Ctrl+Shift+F）时使用 eclipse 默认的"Control Statements"格式化方法进行。',
        characters: 98
    },
    {
        id: 10,
        text: '注：if 语句总是用"{"和"}"括起来。',
        characters: 21
    }
];

export const MOCK_TOTAL_CHUNKS = 221;
